import { Links, Meta, Outlet, Scripts, ScrollRestoration, useRouteError } from "react-router";
import stylesheet from "./tailwind.css?url";

import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { RecoilRoot } from "recoil";
import type { LinksFunction } from "react-router";

// import { withSentry, captureRemixErrorBoundaryError } from "@sentry/react-router";

export const links: LinksFunction = () => [
  { rel: "stylesheet", href: stylesheet },
];

export default function App() {
  return (
    <html>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <link rel="preconnect" href="https://cdn.shopify.com/" />
        <link
          rel="stylesheet"
          href="https://cdn.shopify.com/static/fonts/inter/v4/styles.css"
        />
        <Meta />
        <Links />
      </head>
      <body>
        <RecoilRoot>
          <I18nextProvider i18n={i18n}>
            <Outlet />
          </I18nextProvider>
        </RecoilRoot>
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

// export const ErrorBoundary = () => {
//   const error = useRouteError();
//   captureRemixErrorBoundaryError(error);
//   return <div>Something went wrong</div>;
// };

// export default withSentry(App);
